import { WebPageDetails } from '@/services/analytics/platforms/adobe-analytics/models';
import { BagOffersModalViewEvent } from '@/services/analytics/events';
import { AdobePageLoadEvent } from './adobe-page-load';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { ServicesContainer } from '@/services';

export class AdobeBagOffersModalViewEvent extends AdobePageLoadEvent {
  constructor(event: BagOffersModalViewEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);

    Object.assign(this.web.webPageDetails, {
      pageType: 'modal',
      siteSection: 'order',
      subPageName: 'bag-offers',
      subPageViews: { value: 1 },
      name: 'order:cart:bag-offers',
    } as WebPageDetails);
  }
}
